import React from "react";
import ProfileDetails from "../../components/UI/UserUI/ProfileDetails"
import UseDialogBox from "../../CustomHooks/UseDialogBox";
import ImageSlider from "../../components/UI/viewDialogs/ImageSlider";

const PersonalInfoTab = ({ userData }) => {
  const { showDialogBox, setShowDialogBox } = UseDialogBox();
  return (
    <div className="flex">
      <div className="w-3/6">
        <ProfileDetails title="Full Name" value={userData.fullName} />
        <ProfileDetails title="Email" value={userData.email} />
        <ProfileDetails title="Date of Birth" value={userData.dob} />
        <ProfileDetails title="Gender" value={userData.gender.name} />

        {userData.idProofUrlList && (
          <button
            className="rounded-btn mt-3"
            onClick={() => setShowDialogBox(true)}
          >
            View ID Proof
          </button>
        )}
      </div>
      <div className="w-3/6">
        <ProfileDetails
          title="Bank Name"
          value={userData.bankName?.name ?? "N/A"}
        />
        <ProfileDetails title="IFSC Code" value={userData.ifsc ?? "N/A"} />
        <ProfileDetails
          title="Account Number"
          value={userData.accountNumber ?? "N/A"}
        />
        <ProfileDetails title="Mobile Number" value={userData.mobileNumber} />
        <ProfileDetails
          title="Bike registration no."
          value={userData.bikeRegNumber ?? "N/A"}
        />
      </div>
      {showDialogBox && (
        <ImageSlider
          title="Id Proof Photo"
          images={userData.idProofUrlList}
          imageSliderCurrentIndex={0}
          closeDialogBox={() => setShowDialogBox(false)}
        />
      )}
    </div>
  );
};

export default PersonalInfoTab;
